import { render } from "./BgpPeersTab.vue?vue&type=template&id=9fb0068c&scoped=true"
import script from "./BgpPeersTab.vue?vue&type=script&lang=js"
export * from "./BgpPeersTab.vue?vue&type=script&lang=js"

import "./BgpPeersTab.vue?vue&type=style&index=0&id=9fb0068c&lang=scss&scoped=true"

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fb0068c"]])

export default __exports__